import React from 'react';
import { themes } from './themes';

const VisualSlide = ({ slide, index, total, theme, sizeClass }) => {
  const t = themes[theme] || themes['modern-minimal'];
  const isHook = slide.type === 'hook';
  const isCta = slide.type === 'cta';

  return (
    <div
      className={`w-full ${sizeClass || 'aspect-square'} overflow-hidden relative flex flex-col items-center justify-center text-center p-8 md:p-12 select-none`}
      style={{ backgroundColor: isHook || isCta ? t.accent : t.bg }}
    >
      {/* Decorative */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
        {isHook && (
          <>
            <div className="absolute top-6 left-6 w-20 h-20 rounded-full opacity-10" style={{ backgroundColor: t.bg }} />
            <div className="absolute bottom-10 right-10 w-32 h-32 rounded-full opacity-8" style={{ backgroundColor: t.bg }} />
          </>
        )}
        {!isHook && !isCta && (
          <>
            <div className="absolute top-0 left-0 w-full h-1" style={{ backgroundColor: t.accent + '30' }} />
            <div className="absolute bottom-0 left-0 w-full h-1" style={{ backgroundColor: t.accent + '30' }} />
          </>
        )}
      </div>

      <div className="relative z-10 max-w-[90%]">
        {!isHook && !isCta && (
          <span
            className="inline-block text-[10px] font-bold tracking-[0.2em] uppercase mb-4 px-3 py-1 rounded-full"
            style={{ fontFamily: t.bodyFont, backgroundColor: t.accentLight, color: t.accent }}
          >
            {slide.type === 'engagement' ? 'Your Turn' : `${index} of ${total}`}
          </span>
        )}

        <h2
          className="leading-tight mb-4"
          style={{
            fontFamily: t.font,
            fontWeight: 700,
            fontSize: (isHook || isCta) ? 'clamp(1.5rem, 4vw, 2.25rem)' : 'clamp(1.25rem, 3.5vw, 1.75rem)',
            color: (isHook || isCta) ? t.bg : t.text,
            lineHeight: 1.2
          }}
        >
          {slide.headline}
        </h2>

        {slide.subtext && (
          <p style={{
            fontFamily: t.bodyFont,
            fontSize: 'clamp(0.8rem, 2vw, 1rem)',
            color: (isHook || isCta) ? t.bg + 'CC' : t.subtext,
            maxWidth: '400px',
            margin: '0 auto',
            lineHeight: 1.6
          }}>
            {slide.subtext}
          </p>
        )}

        {isCta && (
          <div
            className="inline-block mt-6 px-6 py-2.5 rounded-full font-semibold text-sm"
            style={{ fontFamily: t.bodyFont, backgroundColor: t.bg, color: t.accent }}
          >
            Follow for more
          </div>
        )}
      </div>

      {/* Dots */}
      <div className="absolute bottom-4 left-0 right-0 flex items-center justify-center gap-1.5">
        {Array.from({ length: total }).map((_, i) => (
          <div
            key={i}
            className="rounded-full transition-all"
            style={{
              width: i === index ? '14px' : '4px',
              height: '4px',
              backgroundColor: (isHook || isCta)
                ? (i === index ? t.bg : t.bg + '50')
                : (i === index ? t.accent : t.accent + '30')
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default VisualSlide;
